export default function Services() {
  const services = [
    {
      icon: 'ri-file-list-3-line',
      title: 'Demissão Sem Justa Causa',
      description: 'Análise completa de verbas rescisórias, aviso prévio, férias proporcionais, 13º salário e FGTS. Verificação de todos os direitos devidos.'
    },
    {
      icon: 'ri-time-line',
      title: 'Horas Extras Não Pagas',
      description: 'Recuperação de horas extras, adicional noturno, trabalho em feriados e finais de semana. Cálculo preciso dos valores devidos.'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Verbas Rescisórias',
      description: 'Conferência e cobrança de todas as verbas devidas na rescisão contratual, incluindo multas e indenizações previstas em lei.'
    },
    {
      icon: 'ri-hospital-line',
      title: 'Acidente de Trabalho',
      description: 'Acompanhamento em casos de acidentes e doenças ocupacionais. Busca por indenizações e benefícios previdenciários.'
    },
    {
      icon: 'ri-team-line',
      title: 'Desvio e Acúmulo de Função',
      description: 'Defesa em casos de exercício de funções diferentes da contratada ou acúmulo de responsabilidades sem a devida remuneração.'
    },
    {
      icon: 'ri-shield-cross-line',
      title: 'Insalubridade e Periculosidade',
      description: 'Reconhecimento e pagamento de adicionais por trabalho em condições insalubres ou perigosas à saúde e segurança.'
    },
    {
      icon: 'ri-user-forbid-line',
      title: 'Assédio Moral e Discriminação',
      description: 'Proteção contra práticas abusivas no ambiente de trabalho. Busca por reparação de danos morais e materiais.'
    },
    {
      icon: 'ri-file-text-line',
      title: 'Revisão de Contratos',
      description: 'Análise preventiva de contratos de trabalho, acordos e termos de rescisão para garantir seus direitos.'
    },
    {
      icon: 'ri-briefcase-line',
      title: 'Vínculo Empregatício',
      description: 'Reconhecimento de vínculo trabalhista em relações disfarçadas como prestação de serviços ou estágio irregular.'
    },
    {
      icon: 'ri-logout-box-r-line',
      title: 'Rescisão Indireta',
      description: 'Quando o empregador descumpre obrigações legais ou contratuais, você pode ter direito à rescisão indireta — equivalente à demissão sem justa causa — com todas as verbas rescisórias devidas.'
    },
    {
      icon: 'ri-arrow-go-back-line',
      title: 'Reversão de Justa Causa',
      description: 'Análise criteriosa dos motivos alegados pelo empregador para a demissão por justa causa. Quando aplicada de forma irregular ou desproporcional, é possível revertê-la e garantir todas as verbas rescisórias.'
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Estabilidade de Gestante',
      description: 'A gestante tem direito à estabilidade no emprego desde a confirmação da gravidez até 5 meses após o parto. Em caso de demissão indevida, é possível buscar a reintegração ou indenização correspondente.'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#4A1C40] mb-4" style={{ fontFamily: 'Crimson Pro, serif' }}>
            Como Posso Te Ajudar
          </h2>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto leading-relaxed" style={{ fontFamily: 'Inter, sans-serif' }}>
            Atuo em diversas áreas do direito trabalhista, sempre com foco na defesa dos seus direitos e na busca por soluções justas e efetivas.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white p-8 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:border-[#C9A961] group"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-[#4A1C40] to-[#5A2C50] rounded-lg mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${service.icon} text-3xl text-[#C9A961]`}></i>
              </div>
              <h3 className="text-xl font-bold text-[#4A1C40] mb-3" style={{ fontFamily: 'Crimson Pro, serif' }}>
                {service.title}
              </h3>
              <p className="text-gray-700 leading-relaxed text-base" style={{ fontFamily: 'Inter, sans-serif' }}>
                {service.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-[#4A1C40] rounded-2xl p-8 text-center">
          <p className="text-white text-lg leading-relaxed" style={{ fontFamily: 'Inter, sans-serif' }}>
            <strong className="text-[#C9A961]">Importante:</strong> Cada caso é único e merece análise individualizada. 
            O resultado de qualquer ação judicial depende das circunstâncias específicas e das provas apresentadas.
          </p>
        </div>
      </div>
    </section>
  );
}